module.exports = __webpack_public_path__ + "static/img/21-Eastbourne-Arndale-Centre.ba510ccd.jpg";